var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlotCardIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 12,
    height: 48,
    rx: 2,
    fill: "#DFE2E7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 5,
    width: 12,
    height: 48,
    rx: 2,
    fill: "#DFE2E7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 5,
    width: 12,
    height: 48,
    rx: 2,
    fill: "#DFE2E7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 11,
    height: 47,
    rx: 1.5,
    fill: "#DFFBE8",
    stroke: "#00004B",
    strokeDasharray: "2 1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 8.5,
    width: 11,
    height: 47,
    rx: 1.5,
    fill: "#DFFBE8",
    stroke: "#00004B",
    strokeDasharray: "2 1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5,
    y: 8.5,
    width: 11,
    height: 47,
    rx: 1.5,
    fill: "#DFFBE8",
    stroke: "#00004B",
    strokeDasharray: "2 1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotCardIcon4);
export default __webpack_public_path__ + "static/media/PlotCardIcon4.4cdf23a0fae54fcf71397f895c2c8bd7.svg";
export { ForwardRef as ReactComponent };